export default __webpack_public_path__ + "static/media/exclamation-triangle.3c5dfe06.svg";